export default "__VITE_ASSET__B9XRBE9U__"